const ErrorPageEN = {
  ErrorPage: {
    CHOOSE_PAGE: 'So how about moving on to one of the other pages?',
    GLOBAL: 'global',
    LISTALL: 'list all',
    RANKING: 'ranking',
    AUDIENCE: 'audience',
    BUDGET: 'budget',
    MEDIA: 'Media',
    ERROR_400_TITLE: 'Error 400',
    ERROR_400_DESCRIPTION:
      "Something has broken here... Our team has been notified and it's currently working on the solution",
    ERRO_404_TITLE: 'Error 404',
    ERRO_404_DESCRIPTION: "This page doesn't exist...",
    ERRO_LOADING_TITLE: 'We identified a server problem',
    ERRO_LOADING_DESCRIPTION: 'Our team is working on it and soon you can get back to that task.',
  },
};

const ErrorPagePT = {
  ErrorPage: {
    CHOOSE_PAGE: 'Então que tal seguir para uma das outras páginas?',
    GLOBAL: 'visão global',
    LISTALL: 'listagem geral',
    RANKING: 'ranking',
    AUDIENCE: 'audiência',
    BUDGET: 'orçamentos',
    MEDIA: 'Mídias',
    ERROR_400_TITLE: 'Erro 400',
    ERROR_400_DESCRIPTION:
      'Alguma coisa quebrou aqui... Nosso time foi notificado e está trabalhando nisso.',
    ERRO_404_TITLE: 'Erro 404',
    ERRO_404_DESCRIPTION: 'Esta página não existe...',
    ERRO_LOADING_TITLE: 'Identificamos um problema no servidor',
    ERRO_LOADING_DESCRIPTION:
      'Nosso time está trabalhando nisso e em breve você consegue voltar à essa tarefa.',
  },
};

export { ErrorPagePT, ErrorPageEN };
